import { createAction } from "@reduxjs/toolkit";
import {
  contentRequestModalType,
  getContentRequestMockDataActionTypes,
  setContentRequestFormActionType,
} from "@redux/contentRequest/actionTypes";

export const getContentRequestMockData = createAction(
  getContentRequestMockDataActionTypes.request,
);

export const getContentRequestMockDataSuccess = createAction(
  getContentRequestMockDataActionTypes.success,
);

export const getContentRequestMockDataFailure = createAction(
  getContentRequestMockDataActionTypes.failure,
);

export const setContentRequestForm = createAction(
  setContentRequestFormActionType,
);

export const toggleContentRequestModal = createAction(contentRequestModalType);
